<template>
    <div class="full-screen-dialog">
        <div class="full-screen-dialog-header">
            <div class="d-flex align-items-center">
                <b-button 
                    variant="transparent" 
                    @click="$emit('sidebar-open')" 
                    v-if="!disableSidebarToggle" v-b-toggle.sidebar-footer> 
                    <i class="fas fa-bars fa-3x text-gray-700" />
                </b-button>
                <b-button
                    variant="transparent"
                    @click="$emit('go-back')"
                    v-if="!headerBackButtonDisabled"
                >
                    <i class="far fa-arrow-left fa-3x text-gray-700"/>
                </b-button>

                <div
                    class="h2 mb-0 ml-2"
                    v-if="headerBackButtonLabel"
                >
                    {{ headerBackButtonLabel }}
                </div>
            </div>

            <div class="ml-auto">
                <slot name="header-actions"/>

                <b-button
                    variant="transparent"
                    @click="$emit('close')"
                    v-if="!headerCloseButtonDisabled"
                >
                    <i class="far fa-times fa-3x text-gray-700"/>
                </b-button>
            </div>
        </div>

        <div class="full-screen-dialog-body">
            <b-container>
                <slot/>
            </b-container>
        </div>
    </div>
</template>

<script>
import './FullScreenDialog.scss';

export default {
    name: 'FullScreenDialog',
    props: {
        headerBackButtonDisabled: {
            type: Boolean,
        },
        headerBackButtonLabel: {
            type: String,
        },
        headerCloseButtonDisabled: {
            type: Boolean,
        },
        disableSidebarToggle:{
            type: Boolean,
            default: true
        }
    },
}
</script>
